import { Flame, AlertTriangle } from "lucide-react";
import { useLang } from "@/lib/i18n";

export function NotFoundState({ error }) {
  const { t } = useLang();
  return (
    <div className="p-8 border border-[#ff3b30]/40 bg-[#ff3b30]/5" data-testid="notfound-state">
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-[#ff3b30] shrink-0 mt-0.5" />
        <div>
          <div className="text-[#ff3b30] font-mono uppercase tracking-widest text-sm mb-1">
            404 // gone
          </div>
          <p className="text-sm text-neutral-700 dark:text-neutral-300">{error || t("notFound")}</p>
        </div>
      </div>
    </div>
  );
}

export function BurnedState() {
  const { t } = useLang();
  return (
    <div className="p-8 border border-[#ff3b30]/40 bg-[#ff3b30]/5" data-testid="burned-state">
      <div className="flex items-start gap-3">
        <Flame className="w-5 h-5 text-[#ff3b30] shrink-0 mt-0.5" />
        <p className="text-sm text-neutral-900 dark:text-neutral-100">{t("burned")}</p>
      </div>
    </div>
  );
}
